import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import './CoreValues.css';
import {
  CAREER_CORE_VALUES_HEADER,
  CAREER_CORE_VALUES_SUBHEADER,
  CAREER_CORE_VALUES_LIST,
} from '../../constants/Careers';

export const CoreValues = () => {
  const [expandedPanels, setExpandedPanels] = useState({});

  //only changing the specific panel, not others.
  const handleChange = (panel) => (_event, isExpanded) => {
    setExpandedPanels((prev) => ({
      ...prev,
      [panel]: isExpanded,
    }));
  };

  return (
    <section className="core-values-container">
      <h2 className="core-values-header">{CAREER_CORE_VALUES_HEADER}</h2>
      <h5 className="core-values-subheader">{CAREER_CORE_VALUES_SUBHEADER}</h5>

      <div className="core-values-list">
        {CAREER_CORE_VALUES_LIST.map(({ title, body }) => (
          <Accordion
            key={title}
            disableGutters
            elevation={0}
            expanded={!!expandedPanels[title]}
            //onChange vs onclick because of mui default behaviors
            onChange={handleChange(title)}
            sx={{
              border: '1px solid black',
              borderRadius: '10px',
              p: '1.25rem',
              //prevents streching of div to match adjacent
              alignSelf: 'flex-start',
              '&.Mui-expanded': {
                alignSelf: 'auto',
              },
              //to prevent default beavhior of the first and last corner being sharper
              '&:first-of-type': {
                borderTopLeftRadius: '10px',
                borderTopRightRadius: '10px',
              },
              '&:last-of-type': {
                borderBottomLeftRadius: '10px',
                borderBottomRightRadius: '10px',
              },
              '&.Mui-expanded:last-of-type': {
                marginBottom: { xs: '1rem', sm: '0' },
              },
              '& .MuiAccordionSummary-root': {
                minHeight: 0,
                m: 0,
                p: 0,
              },
              '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded': {
                m: 0,
                p: 0,
                fontSize: '1.25rem',
              },
              '& .MuiAccordionDetails-root': {
                p: 0,
                mt: '1rem',
              },
            }}
          >
            <AccordionSummary
              //the icon stays the same
              expandIcon={<ExpandMoreIcon className="core-values-section-arrow" />}
              aria-controls={`${title}-content`}
              id={`${title}-header`}
              sx={{ fontWeight: 700, textAlign: 'left' }}
            >
              {title}
            </AccordionSummary>

            <AccordionDetails
              sx={{
                color: '#727272',
                fontFamily: 'sans-serif',
                lineHeight: 1.6,
                fontWeight: 500,
                fontSize: '1rem',
                textAlign: 'left',
              }}
            >
              {body}
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </section>
  );
};
